module.exports = __webpack_public_path__ + "static/media/Maintenance warning.bfc9799a.svg";